<template>
  <div>
    <el-form :inline="true" :model="searchForm">
      <el-form-item label="日期">
        <el-date-picker
          style="width: 250px"
          size="mini"
          v-model="searchForm.createTimeRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          :clearable="false"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="省市">
        <el-cascader
          size="mini"
          style="width: 250px"
          v-model="searchForm.provinceAndCity"
          :options="provinceAndCityOption"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="getData">查询</el-button>
        <el-button type="primary" size="mini" @click="exportToExcel">导出报表</el-button>
      </el-form-item>
    </el-form>
    <div style="padding-top:10px;">共搜索到 {{pageInfo.total}} 条数据</div>
     <div style="padding:10px 0;">
      <el-checkbox :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</el-checkbox>
      <el-button size="mini"  type="primary" @click="batchOrderExport">导出Excel</el-button>
    </div>
    <el-checkbox-group v-model="checkedOrders" @change="handleCheckedChange">
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%">
      <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            <el-checkbox :label="scope.row.index"></el-checkbox>
          </template>
      </el-table-column>
      <el-table-column prop="date" label="日期"></el-table-column>
      <el-table-column prop="province" label="省份" :formatter="codeToText"></el-table-column>
      <el-table-column prop="city" label="市" :formatter="codeToText"></el-table-column>
      <el-table-column prop="seller_add_num" label="新增会员数"></el-table-column>
      <el-table-column prop="num_total" label="累计会员数"></el-table-column>
      <el-table-column prop="sell_num_total" label="累计交易用户"></el-table-column>
      <el-table-column prop="day_active_num" label="日活跃用户数"></el-table-column>
    </el-table>
    </el-checkbox-group>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { CodeToText,provinceAndCityDataPlus } from 'element-china-area-data'
  import util from '../utils/utils'
  
  const StartAndEnd = util.getMonthStartAndEnd(new Date());
  export default {
    name: "seller-count",
    data(){
      return{
        provinceAndCityOption:provinceAndCityDataPlus,
        isIndeterminate:false,
        checkedOrders: [],
        searchForm:{
          createTimeRange:[util.dateFormat(StartAndEnd[0]),util.dateFormat(StartAndEnd[1])],
          provinceAndCity:[],
        },
        tableData:[],
        pageInfo:{
          currentPage:1,
          pageSize:20,
          total:0
        }
      }
    },
    created(){
      this.getData()
    },
    methods:{
      getData(){
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0)'
        });
        util.axiosMethods({
          method:"POST",
          url:"api/seller/sellerCount",
          params:{
            currentPage:this.pageInfo.currentPage,
            pageSize:this.pageInfo.pageSize,
          },
          data:{
            startDate:this.searchForm.createTimeRange ? this.searchForm.createTimeRange[0] :"",
            endDate:this.searchForm.createTimeRange ? this.searchForm.createTimeRange[1] :"",
            province:this.searchForm.provinceAndCity ? this.searchForm.provinceAndCity[0] :"",
            city:this.searchForm.provinceAndCity ? this.searchForm.provinceAndCity[1] :""
          },
          callback:(res => {
            this.tableData = res.data.list.map((item,index)=>{
              item.index = index +1;
              return item;
            })
            this.pageInfo.total = res.data.total
            loading.close()
          }),
          catch:(err => {
            loading.close()
          })
        })
      },
      handleCheckAllChange(val) {
      this.checkedOrders = val
        ? this.tableData.map(item => {
            return item.index;
          })
        : [];
      this.isIndeterminate = false;
    },
     handleCheckedChange(value) {
      let checkedCount = value.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.tableData.length;
    },
      //每页展示数据条数改变
      handleSizeChange(val){
        this.pageInfo.pageSize = val;
        this.getData();
      },
      //页码改变
      handleCurrentChange(val){
        this.pageInfo.currentPage = val;
        this.getData();
      },
      // 省市显示中文
      codeToText(row, column, cellValue, index){
        return CodeToText[cellValue]
      },
    getBatchOrders() {
      if (!this.checkedOrders || this.checkedOrders.length == 0) {
        this.$alert("请选择要导出的数据", "提示", {
          confirmButtonText: "确定",
          type: "warning"
        });
        return null;
      }
      const orders = this.checkedOrders.map(i => {
        const j = i - 1;
        return this.tableData[j].date;
      });
      return orders;
    },
      batchOrderExport(){
        const d = this.getBatchOrders();
        console.log(d)
         const startDate = this.searchForm.createTimeRange ? this.searchForm.createTimeRange[0] :"";
        const endDate = this.searchForm.createTimeRange ? this.searchForm.createTimeRange[1] :"";
        if(d && d.length > 0){
          window.open(
          "/api/seller/sellerCountExportByIdToExcel?ids=" + d.join(",") + '&startDate='+startDate+'&endDate='+endDate,
          "_parent"
        );
        }
      },
      //导出
      exportToExcel(){
        const startDate = this.searchForm.createTimeRange ? this.searchForm.createTimeRange[0] :"";
        const endDate = this.searchForm.createTimeRange ? this.searchForm.createTimeRange[1] :"";
        const province = this.searchForm.provinceAndCity ? this.searchForm.provinceAndCity[0] :"";
        const city = this.searchForm.provinceAndCity ? this.searchForm.provinceAndCity[1] :"";
        window.open("/api/seller/sellerCountExportToExcel?gold=1&startDate="+startDate+"&endDate="+endDate+"&province="+province+"&city="+city,"_parent");
      },
    }
  }
</script>

<style scoped>
  .block{
    float: right;
    margin-top: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/sellerCount.vue